const tableResources = {
    labelShow:'Show',
    labelPage: 'Page',
    labelOf:'of',
    textNoDataFound:'No data found'
};
export default tableResources;